<template>
  <v-container fluid>
    <v-app-bar app color="white">
      <v-img src="../../images/fishbone-logo.jpg" :min-width="isMobile ? 100 : 900" class="mr-4 logo"></v-img>

      <v-spacer></v-spacer>
      <v-btn :href="'/Dashboard'" color="primary" class="mr-3">
        <v-icon left>mdi-logout</v-icon>
        {{ $t('app.regresar') }}
      </v-btn>

      <!--         <v-btn icon v-if="isMobile" @click="showPatientInfo = !showPatientInfo">
          <v-icon>mdi-menu</v-icon>
        </v-btn> -->
    </v-app-bar>

    <!-- Botón para agregar parámetro -->
    <v-btn color="primary" class="mt-4" @click="abrirFormularioNuevo">
      {{ $t('app.agregarParametro') }}
    </v-btn>


    <!-- Tabla de parámetros -->
    <v-data-table :headers="headers" :items="parameters" dense class="mt-4" :mobile-breakpoint="600">
      <template v-slot:item.acciones="{ item }">
        <v-btn color="blue" small icon @click="editarParametro(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn color="red" small icon @click="confirmarEliminar(item.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Modal para agregar/editar parámetro -->
    <v-dialog v-model="dialogAgregar" :fullscreen="isMobile" scrollable>
      <v-card>
        <v-card-title>{{ editando ? 'Editar' : 'Agregar' }} Parámetro</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field v-model="form.parametro" :label="$t('Parametros.parametro')"></v-text-field>
            <v-text-field v-model="form.valorMostrado" :label="$t('Parametros.valorMostrado')"></v-text-field>
            <v-text-field v-model="form.valorBajo" :label="$t('Parametros.valorBajo')"></v-text-field>
            <v-text-field v-model="form.valorAlto" :label="$t('Parametros.valorAlto')"></v-text-field>
            <v-text-field v-model="form.units" :label="$t('Parametros.unidades')"></v-text-field>
            <v-text-field v-model="form.rango" :label="$t('Parametros.rango')"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="guardarParametro" color="primary">{{ $t('app.save') }}</v-btn>
          <v-btn @click="dialogAgregar = false">{{ $t('app.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmación de eliminación -->
    <v-dialog v-model="dialogEliminar" max-width="400px">
      <v-card>
        <v-card-title>{{ $t('Parametros.eliminarParametro') }}</v-card-title>
        <v-card-text>{{ $t('Parametros.advertencia') }}</v-card-text>
        <v-card-actions>
          <v-btn color="red" @click="eliminarParametro">{{ $t('Parametros.eliminar') }}</v-btn>
          <v-btn @click="dialogEliminar = false">{{ $t('Parametros.cancelar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  data() {
    return {
      parameters: [],
      dialogAgregar: false,
      dialogEliminar: false,
      editando: false,
      idEliminar: null,
      form: { parametro: "", valorMostrado: "", valorBajo: "", valorAlto: "", units: "", rango: "" },
      headers: [
        { text: "Parámetro", value: "parametro" },
        { text: "Valor Mostrado", value: "valorMostrado" },
        { text: "Valor Bajo", value: "valorBajo" },
        { text: "Valor Alto", value: "valorAlto" },
        { text: "Unidades", value: "units" },
        { text: "Rango", value: "rango" },
        { text: "Acciones", value: "acciones", sortable: false },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.display.mdAndDown;
    },
  },
  methods: {
    abrirFormularioNuevo() {
      this.form = {
        enfermedad: "",
        descripcion: "",
        tratamiento: "",
        sup_enfermedad: null,
      };
      this.editando = false;
      this.dialogAgregar = true;
    },
    async cargarParametros() {
      const res = await axios.get(`${apiUrl}/api/parameters`);
      this.parameters = res.data;
    },
    editarParametro(item) {
      this.form = { ...item };
      this.editando = true;
      this.dialogAgregar = true;
    },
    async guardarParametro() {
      if (this.editando) {
        await axios.put(`${apiUrl}/api/parameters/update/${this.form.id}`, this.form);
      } else {
        await axios.post(`${apiUrl}/api/parameters/create`, this.form);
      }
      this.dialogAgregar = false;
      this.cargarParametros();
    },
    confirmarEliminar(id) {
      this.idEliminar = id;
      this.dialogEliminar = true;
    },
    async eliminarParametro() {
      await axios.delete(`${apiUrl}/api/parameters/delete/${this.idEliminar}`);
      this.dialogEliminar = false;
      this.cargarParametros();
    },
  },
  mounted() {
    this.cargarParametros();
  },
};
</script>

<style scoped>
.logo {
  max-height: 50px;
}
</style>